<template>
  <div>
    <img src="../assets/userReadBg.png" style="width: 100%;" />
    <div class="contentBg">
      <p class="title">1. 為保護未成年人權益，未成年人禁止進行任何儲值及打賞行為。</p>
      <p class="title">2. 使用者透過儲值取得之虛擬幣，僅限用於平台內打賞使用，不得轉讓、兌換現金或提領。</p>
      <p class="title">3. 請使用者合理觀看內容、理性消費打賞，勿過度投入。</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  document.title = '用戶須知'
})
</script>

<script>
export default {
  name: 'UserRead'
}
</script>

<style scoped>
.contentBg{
position: absolute;
  top: 0px;
  left: 0px;
  margin-top: 180px;
  margin-left: 50px;
  margin-right: 50px;
}
.title {
  font-size: 16px;
  color: black;
  font-weight: medium;
  text-align: left;
  text-indent: 2em;
}
</style>